import { z } from 'zod';
export const ApplicationIntentSchema = z.object({
    id: z.number().optional(),
    jobId: z.string(),
    applicationType: z.enum([
        'full',
        'quick',
        'phone',
        'external',
        'info',
        'letter',
        'personal',
        'direct_link'
    ]),
    status: z.enum(['initiated', 'completed']).optional(),
    source: z.string().optional(),
    firstName: z.string().optional().nullable(),
    lastName: z.string().optional().nullable(),
    email: z.string().optional().nullable()
});
//# sourceMappingURL=applicationIntentSchema.js.map